import React, { useContext, useEffect, useState } from 'react'
import { IonCol, IonGrid, IonPage, IonRow } from '@ionic/react'
import { Feedback, Modal } from 'app-principal-componentes-visuales'
import { capitalizeString } from '../../utils/utils'
import { ASISTENCIA_CREADA, COMPONENTE_ASISTENCIA_CREADA, HOME, TITULO_PREGUNTA } from '../../utils/constants'
import Contactanos from '../../components/Modals/Contactanos/Contactanos'
import { AsistenciaMedicaContext } from '../../contexts/AsistenciaMedicaContext'
import { GA_KEYS, mapGA } from '../../helpers/GTM'
import { TextoComponente } from '../../interfaces/textoComponente.interface'
import { useCapacitor } from '../../hooks/useCapacitor'
import './AsistenciaSolicitada.scss'

const AsistenciaSolicitada = ({ history }) => {
    let { socio, sendCasoResponse, caso } = history.location.state;
    const { setupData, asistenciaMedica, isWeb, checkPermissions } = useContext(AsistenciaMedicaContext);
    const { openAppSettings } = useCapacitor();
    const [isNotification, setIsNotification] = useState(false);
    const [showContactanosModal, setShowContactanosModal] = useState(false);
    const textoComponenteAsistenciaCreada: TextoComponente = asistenciaMedica.textoComponentes.find((textoComponente) => textoComponente.componente === COMPONENTE_ASISTENCIA_CREADA);
    const mensajeCMO = sendCasoResponse?.codigoSubTipoServicio === 'CMO' ? '\nIngresá a whatsapp y/o mail para acceder a la asistencia solicitada.' : '';

    useEffect(() => {
        checkPermissions().then(notificationsSettings => setIsNotification(notificationsSettings));
        const tipoServicio = `${sendCasoResponse.codigosubtiposervicio}-${sendCasoResponse.codigotiposervicio}`

        const configGA = {
            tipo_de_servicio: tipoServicio
        }

        mapGA(GA_KEYS.NUEVO_CASO_ASISTENCIA, setupData, configGA)
    }, [])

    const handleVolverInicio = () => {
        history.push(HOME, { seguimiento: false, from: ASISTENCIA_CREADA });
    }

    const handleIrASeguimiento = () => {
        history.push(HOME, { seguimiento: true, from: history.location.pathname, nroCaso: caso });
    }

    const handleNotificaciones = () => {
        openAppSettings();
    }

    return (
        <IonPage>
            <div className="asistencia-error_page AsistenciaSolicitada">
                <IonGrid className={`${isWeb ? 'asistencia_content-container asistencia-web-mobile-padding' : ''}`}>
                    <IonRow>
                        <IonCol size='12'>
                            {
                                (sendCasoResponse?.codigoSubTipoServicio === "CMO" && !isNotification && !isWeb) ?
                                    <Feedback
                                        activarNotificacion={<>Activá las notificaciones de la app OSDE en tu celular para recibir novedades sobre esta asistencia.</>}
                                        asistencia
                                        labelButtonCancel={textoComponenteAsistenciaCreada.botones.find(btn => btn.nombre === 'volver-inicio-ac').texto}
                                        labelButtonOk={textoComponenteAsistenciaCreada.botones.find(btn => btn.nombre === 'seguimiento-ac').texto}
                                        onClickActNot={() => handleNotificaciones()}
                                        onClickCancel={() => handleVolverInicio()}
                                        onClickOk={() => handleIrASeguimiento()}
                                        parrafo={`${textoComponenteAsistenciaCreada.subtitulo} ${capitalizeString(socio.nombre)}${mensajeCMO}`}
                                        titulo={textoComponenteAsistenciaCreada.titulo}
                                        id="feedback-asistencia-solicitada-seguimiento"
                                    />
                                    :
                                    <Feedback
                                        asistencia
                                        handsPhoneReady
                                        labelButtonCancel={textoComponenteAsistenciaCreada.botones.find(btn => btn.nombre === 'volver-inicio-ac').texto}
                                        labelButtonOk={textoComponenteAsistenciaCreada.botones.find(btn => btn.nombre === 'seguimiento-ac').texto}
                                        onClickCancel={() => handleVolverInicio()}
                                        onClickOk={() => handleIrASeguimiento()}
                                        parrafo={`${textoComponenteAsistenciaCreada.subtitulo} ${capitalizeString(socio.nombre)}${mensajeCMO}`}
                                        titulo={textoComponenteAsistenciaCreada.titulo}
                                        id="feedback-asistencia-solicitada-seguimiento"
                                    />
                            }
                        </IonCol>
                    </IonRow>
                </IonGrid>
                <Modal
                    className='modal_web'
                    hideCloseBtn={false}
                    //@ts-ignore
                    //TODO VALIDAR QUE MODAL MOSTRAR
                    component={<Contactanos setupData={setupData} screen={'servicio_vigente'} sintomas texto={null} titulo={TITULO_PREGUNTA} />}
                    setShowModal={setShowContactanosModal}
                    showModal={showContactanosModal}
                    id='contactanos'
                />
            </div>
        </IonPage>
    )
}

export default AsistenciaSolicitada